(() => {
  if (customElements.get('ac-creator-video')) return;
  class CreatorVideo extends HTMLElement {
    connectedCallback() {
      this.innerHTML = `<dialog class="ac-creator-dialog" aria-labelledby="ac-creator-video-title">
        <div class="ac-creator-dialog__header"><span id="ac-creator-video-title"></span><button type="button" aria-label="Close video" class="ac-creator-dialog__close">×</button></div>
        <div class="ac-creator-dialog__player"></div>
        <a class="ac-creator-dialog__original" target="_blank" rel="noopener noreferrer">View original on Instagram ↗</a>
      </dialog>`;
      this.dialog = this.querySelector('dialog');
      this.player = this.querySelector('.ac-creator-dialog__player');
      this.querySelector('button').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        const video = this.player.querySelector('video');
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
        }
        this.player.replaceChildren();
        document.documentElement.style.overflow = this.previousOverflow;
        this.trigger?.focus({preventScroll:true});
      });
    }
    open(link, shortcode) {
      this.trigger = link;
      this.querySelector('#ac-creator-video-title').textContent = link.dataset.creator || 'Player video';
      this.querySelector('.ac-creator-dialog__original').href = link.href;
      let media;
      if (link.dataset.videoUrl) {
        media = document.createElement('video');
        media.controls = true;
        media.playsInline = true;
        media.preload = 'none';
        media.autoplay = false;
        const cover = link.querySelector('img');
        if (cover) media.poster = cover.currentSrc || cover.src;
        media.setAttribute('aria-label', `Video by ${link.dataset.creator || 'Acemate player'}`);
        media.src = link.dataset.videoUrl;
      } else {
        media = document.createElement('iframe');
        media.title = `Instagram video by ${link.dataset.creator || 'Acemate player'}`;
        media.allow = 'fullscreen; picture-in-picture';
        media.allowFullscreen = true;
        media.src = `https://www.instagram.com/p/${shortcode}/embed/`;
      }
      this.player.replaceChildren(media);
      if (media.tagName === 'VIDEO') {
        const playButton = document.createElement('button');
        playButton.type = 'button';
        playButton.className = 'ac-creator-dialog__play';
        playButton.setAttribute('aria-label', 'Play video');
        playButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>';
        playButton.addEventListener('click', () => {
          media.play().catch(() => { playButton.hidden = false; });
        });
        media.addEventListener('play', () => {
          if (document.activeElement === playButton) media.focus({preventScroll: true});
          playButton.hidden = true;
        });
        media.addEventListener('pause', () => { playButton.hidden = false; });
        media.addEventListener('ended', () => { playButton.hidden = false; });
        this.player.append(playButton);
      }
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.dialog.showModal();
    }
  }
  customElements.define('ac-creator-video', CreatorVideo);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[data-ac-creator-video]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href);
    const shortcode = url.pathname.match(/^\/(?:p|reel|reels)\/([A-Za-z0-9_-]+)\/?$/)?.[1];
    if (!/^(www\.)?instagram\.com$/.test(url.hostname) || !shortcode) return;
    event.preventDefault();
    let player = document.querySelector('ac-creator-video');
    if (!player) {
      player = document.createElement('ac-creator-video');
      document.body.append(player);
    }
    player.open(link, shortcode);
  });
})();
